import { render, staticRenderFns } from "./PbDashboard.vue?vue&type=template&id=2ed0aa48&scoped=true&"
import script from "./PbDashboard.js?vue&type=script&lang=js&"
export * from "./PbDashboard.js?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=2ed0aa48&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed0aa48",
  null
  
)

export default component.exports